import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import {Observable, of} from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import {ErrorService, EventService, StatusResponse} from '..';
import {UserResponse, User, UserRole, UserApiKey} from '../models/user';
import { ConfigService } from './config.service';
import {UserActivationRequest} from '../models';


@Injectable({providedIn: 'root'})
export class UserActivationService {

    private baseUrl = ConfigService.getApiEndpoint() + 'v1/useractivation/';

    constructor(
        private http: HttpClient,
        private eventService: EventService,
        private error: ErrorService
    ) { }

    getUser(token: string): Observable<User> {
        return this.http.get<User>(this.baseUrl + token);
    }

    activateUser(token: string, userActivationRequest: UserActivationRequest, mode: string): Observable<User> {
        return this.http.post<User>(this.baseUrl + token, userActivationRequest)
            .pipe(tap((_) => this.eventService.addAlert(mode === 'recover' ? 'user password reset' : 'user activated')),
                catchError(this.error.handleError(mode === 'recover' ? 'could reset password' : 'could not activate user', null))
            );
    }

    recoverPassword(email: string): Observable<StatusResponse> {
        let params = {
            email: email
        };
        return this.http.put<StatusResponse>(this.baseUrl + 'recover', null , { params: params}  ).pipe(
            tap(_ => this.eventService.addAlert(`requested password recovery`)),
            catchError(this.error.handleError('could not request password recovery', null))
        );
    }

}
